import { ol_style } from "@omnia/exports/openlayers";

export class EditBoundaryLayer extends omnia.map.Layer {


    getLayerStyleFunction(selected: boolean): (feature, resolution) => any {

        let fillColor = (selected ? [255, 255, 255, 0.5] : [255, 255, 255, 0.2]);
        let lineDash = (selected ? undefined : [6, 6]);

        return (feature, resolution) => {

            let styles = [
                new ol_style.Style({
                    fill: new ol_style.Fill({
                        color: fillColor
                    }),
                    stroke: new ol_style.Stroke({
                        color: "black",
                        lineDash: lineDash,
                        width: 2
                    }),
                })
            ];

            let textStyles = omnia.map.styles.getTextStyles(resolution, [{ text: feature.get("data") }]);

            styles = styles.concat(textStyles);

            return styles;

        }

    }

}
